import { IPayloadAction, ScannerActions } from './scanner.actions';
import { IScannerStatus } from '../interfaces';

export function scannerStatusReducer(state: IScannerStatus , action: IPayloadAction) {
  switch (action.type) {

    /* istanbul ignore next */
    case ScannerActions.APPLICATION_BATCH_ERROR:
      return { ...state, current: 'application_error', busy: true };

    case ScannerActions.LOAD_SCANNER:
      return { ...state, current: 'loading' };

    case ScannerActions.SCANNER_LOADED:
      return { ...state, current: 'loaded' };

    case ScannerActions.INITIALIZE_SCANNER:
      return { ...state, current: 'initializing' };

    case ScannerActions.SCANNER_INITIALIZED:
      return { ...state, current: 'ready', initialized: true };

    case ScannerActions.SCANNER_LIST_RECEIVED:
      return { ...state, availableScanners: action.payload };

    case ScannerActions.SCANNER_SELECTED:
      return { ...state, activeScanner: action.payload };

    case ScannerActions.ACQUIRE_IMAGES:
      return { ...state, current: 'scanning', busy: true };

    case ScannerActions.IMAGES_ACQUIRED:
      return { ...state, current: 'ready', busy: false };

    case ScannerActions.NOTHING_TO_SCAN:
      return { ...state, current: 'ready', busy: false };

    case ScannerActions.SEND_IMAGES_BATCH:
      return { ...state, current: 'sending' };

    case ScannerActions.IMAGES_BATCH_SENT:
      return { ...state, current: 'ready' };

    case ScannerActions.DESTROY_SCANNER:
      return { ...state, current: 'destroying', busy: true };

    case ScannerActions.SCANNER_DESTROYED:
      return { ...state, current: 'uninitialized', initialized: false, busy: false };

    case ScannerActions.FETCH_API_STATUS:
      return {...state, apiOffline: false};

    case ScannerActions.FETCH_API_STATUS_SUCCESS:
      return {...state, apiOffline: false};

    case ScannerActions.FETCH_API_STATUS_ERROR:
      return {...state, apiOffline: true};

    default:
      return state;

  }
}
